import type { Directive } from 'vue'
import { InteractionElement, InteractionType } from '@src/types/events.types'
import { getPrefixedAttributes } from '@src/utilities/trackingUtils'

const attributePrefixRegex = /^data-tracking-prop-/

function getTrackingElement(tagName: string): InteractionElement | undefined {
  const elementMap: Record<string, InteractionElement> = {
    A: 'link',
    BUTTON: 'button',
    INPUT: 'input_field',
    SELECT: 'dropdown_menu',
    I: 'icon',
    LI: 'list_item'
  }
  return elementMap[tagName]
}

const trackingDirective: Directive = {
  beforeMount(el, binding) {
    const eventType = binding.arg ?? 'click'
    const eventName: string = binding.value
    const additionalProps = getPrefixedAttributes(el, attributePrefixRegex)

    const handler = () => {
      const eventProps = {
        type: eventType as InteractionType,
        element: getTrackingElement(el.tagName),
        component: binding.instance?.$options?.name,
        ...additionalProps
      }

      if (binding.modifiers.debug) {
        console.table({ eventName, ...eventProps }) // eslint-disable-line no-console
      }

      (binding.instance as any)?.$trackMixpanelEvent?.(eventName, eventProps)
    }

    // Store the handler so we can remove it in unmounted
    // eslint-disable-next-line no-param-reassign
    el.__trackHandler__ = handler
    el.addEventListener(eventType, handler)
  },

  unmounted(el, binding) {
    const eventType = binding.arg ?? 'click'
    el.removeEventListener(eventType, el.__trackHandler__)
    // eslint-disable-next-line no-param-reassign
    delete el.__trackHandler__
  }
}

export default trackingDirective
